<template>
    <div class="solution">
        <div class="main">
            <div class="titbox">
                <h3>解决方案</h3>
                <!-- <p>实现异构、异主、异地数据便捷、安全、可控、开放的互联互通与安全共享，帮助机构、企业降低成本、提升效率，提升安全性</p> -->
            </div>
            <swiper class="swiper swiperList" :options="swiperOption">
                <swiper-slide v-for="item of productsList" :key="item.id">
                  <div class="cardBox">
                    <router-link :to="item.path">
                      <i class="i-toggle-nav i-toggle-1">
                        <img :src=item.img :alt="item.title">
                      </i>
                      <h3>{{item.title}}</h3>
                      <p>{{item.text}}</p>
                    </router-link>
                  </div>
                </swiper-slide>
                <div class="swiper-button swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Solution',
  data () {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      productsList: [
        {
          id: '1',
          title: '行业/领域节点解决方案',
          text: '以Handle标识解析体系为基础，利用Handle分布式存储架构，遵循先进性、开放性、安全性、集成性、可扩展性等原则，建设标识解析信息系统，为各个行业提供行业/领域节点基础服务能力，包括标识注册、标识解析、标识代理服务、数据同步、业务综合管理等，达到对行业规范管理，加强统筹，资源共享，提升安全的目的。',
          img: require('../../assets/img/icon/icon_1.png'),
          path: '/Field-Node'
        },
        {
          id: '2',
          title: '全生命周期追溯解决方案',
          text: '利用Handle技术分布式存储架构，在每个产业链中的企业均部署Handle本地服务器和系统，企业将需要实时共享数据和信息存入本地Handle服务器，同时可通过Handle系统自带的权限控制功能向企业定向开放数据，做到“我的数据我做主”，以实现上下游企业间信息的高效实时共享。以此形成服务于追溯应用的分布式虚拟资源池，为客户、政府提供完整的全生命周期追溯服务。',
          img: require('../../assets/img/icon/icon_2.png'),
          path: '/life-cycle'
        },
        {
          id: '3',
          title: '类电子政务系统解决方案',
          text: '为具有协同需求的机构或部门部署本地Handle服务，实现在各机构数据自主可控的前提下的信息安全共享，实现机构间信息互联互通，并支撑各类应用服务。',
          img: require('../../assets/img/icon/icon_3.png'),
          path: '/class-electronic'
        },
        {
          id: '4',
          title: '智能供应链解决方案',
          text: '利用Handle技术特性，建立分布式的智能供应链，在企业“我的数据我做主”的原则下，实现供应链上下游企业间信息自主可控的高效实时共享，实现全供应链质量追溯管理、故障跟踪分析、仓储物流改善，为企业提供供应链数据支撑，实现降本增效。',
          img: require('../../assets/img/icon/icon_4.png'),
          path: '/smart-chain'
        },
        {
          id: '5',
          title: '模拟根解决方案',
          text: '为特定行业或逻辑区域建立的模拟Handle根节点，为整个区域提供根节点服务，以帮助建立在局域网或区域隔离网络环境下的数据标识解析体系，实现异主、异地、异构系统、数据间的互联互通。模拟根能够支持各类Handle产品、服务与解决方案在非互联网环境下的应用。',
          img: require('../../assets/img/icon/icon_5.png'),
          path: '/simulation-root'
        },
        {
          id: '6',
          title: 'Handle实验室解决方案',
          text: 'Handle实验室提供Handle基础环境，开发者可学习Handle基础知识，模拟各类实际环境，实践基于Handle基础架构上数据应用服务的开发。Handle实验室主要用于教学、实验。',
          img: require('../../assets/img/icon/icon_6.png'),
          path: '/Laboratory'
        }
      ]
    }
  },
  created () {
    this.clietWidth()
  },
  methods: {
    clietWidth () {
      const clientWidth = document.body.clientWidth
      if (clientWidth < 1000) {
        this.swiperOption.slidesPerView = 1
      } else {
        this.swiperOption.slidesPerView = 3
      }
      console.log(this.swiperOption.slidesPerView)
    }
  }
}
</script>

<style lang="less" scoped>
.solution{
    width:100%;
    background: url("../../assets/img/home/soluteBg.png") no-repeat;
    background-size:100% 100% ;
    .main{
      width:1200px;
      margin:auto;
      padding-bottom: 80px;
      .titbox{
        width: 100%;
        text-align: center;
        color:#fff;
        padding:70px 0;
        h3{
          font-size: 36px;
          line-height: 1.3;
        }
        p{
          font-size: 16px;
          margin-top:15px
        }
      }
      .swiper-slide {
        width:370px;
      }
      .swiperList{
        padding:30px 10px;
        background: #fff;
        border-radius: 3px;
        .cardBox {
          position: relative;
          top:0;
          padding: 0 20px;
          text-align: justify;
          color:#616161;
          transition: all .3s ease-out;
          a{
            display: block;
            width:100%;
            height:100%;
            color: #333;
            .i-toggle-nav,
            .i-toggle-1{
              width:160px;
              height:160px;
              overflow: hidden;
            }
            .i-toggle-nav{
              display: block;
              margin:0 auto 20px;
            }
            .i-toggle-1 img{
              width:100%
            }
            h3{
              position: relative;
              margin-bottom: 10px;
              padding-bottom: 10px;
              font-weight: bold;
              font-size: 16px;
              text-align: center;
              color: #333;
            }
          }
          .swiper-button {
            opacity: 0.1;
            transition: all .3s ease-out;
          }
          .swiper-button:hover {
            opacity: 1;
          }
        }
        .cardBox:hover {
          top: -5px;
        }
      }
    }
}
@media screen and (max-width:1000px) {
  .solution{
    .main{
      width:100%;
      .swiperList{
        padding:30px 10px;
        background: #fff;
        border-radius: 3px;
        .cardBox {
          width:370px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/Solution.vue